import { TMS_COLORS } from '@constants'

type IconProps = { color?: string; size?: number }

export function DeleteIcon({ color = 'currentColor', size = 18 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 11.25V23.75H10V11.25H20ZM18.125 3.75H11.875L10.625 5H6.25V7.5H23.75V5H19.375L18.125 3.75ZM22.5 8.75H7.5V23.75C7.5 25.125 8.625 26.25 10 26.25H20C21.375 26.25 22.5 25.125 22.5 23.75V8.75Z"
        fill={color}
      />
    </svg>
  )
}

export function PaymentDownloadIcon({ color = 'currentColor', size = 15 }: IconProps) {
  return (
    <svg width={size} height={(size / 15) * 18} viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 15.8684H15V18H0V15.8684Z" fill={color} />
      <path d="M4.45312 0H10.3125V6.39474H14.5312L7.5 13.7368L0.46875 6.39474H4.45312V0Z" fill={color} />
    </svg>
  )
}

export function UpdateIcon({ color = 'currentColor', size = 18 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.53124 4.96924C4.14916 2.57417 6.88946 1 9.99644 1C14.9679 1 18.9976 5.0297 18.9976 10.0004C18.9976 10.3297 18.9809 10.655 18.9451 10.9756"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.02345 2.19336L1.62321 6.06476L5.38722 5.8468" fill={color} />
      <path
        d="M17.4656 15.1079C15.8485 17.5022 13.1082 19.0787 10.0004 19.0787C5.0289 19.0787 0.999996 15.0467 0.999996 10.0776C0.999996 9.74745 1.0167 9.42212 1.0517 9.10156"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18.977 17.8378L18.3773 13.9648L14.6133 14.1844" fill={color} />
    </svg>
  )
}

export function DownloadIcon({ color = 'currentColor', size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill={color} />
    </svg>
  )
}

export function CopyIcon({ color = TMS_COLORS.blue[40], size = 24 }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      xmlSpace="preserve"
    >
      <g id="Bounding_Boxes">
        <g id="ui_x5F_spec_x5F_header_copy_3"></g>
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g id="Outline">
        <g id="ui_x5F_spec_x5F_header" fill={color}></g>
        <path
          id="XMLID_339_"
          d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v5h5v11 L6,20z"
          fill={color}
        />
      </g>
    </svg>
  )
}
